import React, {useEffect, useMemo, useState} from "react";
import {get} from "lodash";
import {Editor} from "@monaco-editor/react";
import {Box} from "@mui/material";

const FormikEditorField = ({ name, label, formik, language, height }) => {
  const [value, setValue] = useState('');
  const formikValue = get(formik.values, name);
  const hasError = formik.touched[name] && Boolean(formik.errors[name]);

  useEffect(() => {
    setValue(formikValue);
  }, [formikValue]);

  const helperText = useMemo(() => {
    if (hasError) {
      return formik.errors[name];
    }
    return '';
  }, [formik, name, hasError]);

  return (
    <Box sx={{ border: "1px solid #0000003b", borderRadius: "4px", width: "100%" }}>
      <Editor
        value={value}
        onChange={event => {
          const newValue = event;
          setValue(newValue);
          formik.setFieldValue(name, newValue);
        }}
        language={language || "javascript"}
        height={height || "30vh"}
      />
    </Box>
  );
}

export default FormikEditorField;